"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _PerspectiveCamera_converter, _PerspectiveCamera_tree, _PerspectiveCamera_aspect, _PerspectiveCamera_domEventEngine, _PerspectiveCamera_fov;
Object.defineProperty(exports, "__esModule", { value: true });
exports.PerspectiveCamera = void 0;
const viewer_shared_math_1 = require("@shapediver/viewer.shared.math");
const viewer_shared_node_tree_1 = require("@shapediver/viewer.shared.node-tree");
const viewer_shared_services_1 = require("@shapediver/viewer.shared.services");
const viewer_shared_types_1 = require("@shapediver/viewer.shared.types");
const gl_matrix_1 = require("gl-matrix");
const PerspectiveCameraControls_1 = require("../controls/PerspectiveCameraControls");
const AbstractCamera_1 = require("./AbstractCamera");
class PerspectiveCamera extends AbstractCamera_1.AbstractCamera {
    // #endregion Properties (6)
    // #region Constructors (1)
    constructor(id, version, initialAspect, isDefault = false) {
        super(id, viewer_shared_types_1.CAMERA_TYPE.PERSPECTIVE, version, isDefault);
        // #region Properties (6)
        _PerspectiveCamera_converter.set(this, viewer_shared_services_1.Converter.instance);
        _PerspectiveCamera_tree.set(this, viewer_shared_node_tree_1.Tree.instance);
        _PerspectiveCamera_aspect.set(this, void 0);
        _PerspectiveCamera_domEventEngine.set(this, void 0);
        _PerspectiveCamera_fov.set(this, 60);
        __classPrivateFieldSet(this, _PerspectiveCamera_aspect, initialAspect, "f");
        this._controls = new PerspectiveCameraControls_1.PerspectiveCameraControls(this, true);
    }
    // #endregion Constructors (1)
    // #region Public Getters And Setters (6)
    get aspect() {
        return __classPrivateFieldGet(this, _PerspectiveCamera_aspect, "f");
    }
    set aspect(value) {
        __classPrivateFieldSet(this, _PerspectiveCamera_aspect, value, "f");
    }
    get controls() {
        return this._controls;
    }
    set controls(value) {
        this._controls = value;
    }
    get fov() {
        return __classPrivateFieldGet(this, _PerspectiveCamera_fov, "f");
    }
    set fov(value) {
        __classPrivateFieldSet(this, _PerspectiveCamera_fov, value, "f");
    }
    // #endregion Public Getters And Setters (6)
    // #region Public Methods (6)
    applySettings(settingsEngine) {
        var _a;
        const cameraSetting = (settingsEngine.camera.cameras[this.id]);
        if (cameraSetting) {
            this.name = cameraSetting.name;
            this.autoAdjust = cameraSetting.autoAdjust;
            this.cameraMovementDuration = cameraSetting.cameraMovementDuration;
            this.enableCameraControls = cameraSetting.enableCameraControls;
            this.initialAutoAdjust = cameraSetting.initialAutoAdjust;
            this.revertAtMouseUp = cameraSetting.revertAtMouseUp;
            this.revertAtMouseUpDuration =
                cameraSetting.revertAtMouseUpDuration;
            this.sceneRotation = gl_matrix_1.vec2.fromValues(cameraSetting.sceneRotation.x, cameraSetting.sceneRotation.y);
            this.zoomExtentsFactor = cameraSetting.zoomExtentsFactor;
            const position = __classPrivateFieldGet(this, _PerspectiveCamera_converter, "f").toVec3(cameraSetting.position);
            const target = __classPrivateFieldGet(this, _PerspectiveCamera_converter, "f").toVec3(cameraSetting.target);
            this.defaultPosition = gl_matrix_1.vec3.clone(position);
            this.defaultTarget = gl_matrix_1.vec3.clone(target);
            this.position = position;
            this.target = target;
            this.fov = cameraSetting.fov;
        }
        if (this.position[0] === this.target[0] &&
            this.position[1] === this.target[1] &&
            this.position[2] === this.target[2]) {
            if (this._viewportId) {
                (_a = this._stateEngine.viewportEngines[this._viewportId]) === null || _a === void 0 ? void 0 : _a.boundingBoxCreated.then(() => __awaiter(this, void 0, void 0, function* () {
                    yield this.zoomTo(undefined, { duration: 0 });
                    this.defaultPosition = gl_matrix_1.vec3.clone(this._controls.position);
                    this.defaultTarget = gl_matrix_1.vec3.clone(this._controls.target);
                }));
            }
        }
        this._controls.applySettings(settingsEngine);
    }
    assignViewer(renderingEngine) {
        var _a;
        if (renderingEngine.closed)
            throw new viewer_shared_services_1.ShapeDiverViewerCameraError(`OrthographicCamera(${this.id}).assignViewer: Viewer with id ${renderingEngine.id} not found.`);
        this.assignViewerInternal(renderingEngine.id);
        this._controls.assignViewer(renderingEngine.id, renderingEngine.canvas);
        if (this.domEventListenerToken && __classPrivateFieldGet(this, _PerspectiveCamera_domEventEngine, "f"))
            __classPrivateFieldGet(this, _PerspectiveCamera_domEventEngine, "f").removeDomEventListener(this.domEventListenerToken);
        __classPrivateFieldSet(this, _PerspectiveCamera_domEventEngine, renderingEngine.domEventEngine, "f");
        this.domEventListenerToken = __classPrivateFieldGet(this, _PerspectiveCamera_domEventEngine, "f").addDomEventListener(this._controls
            .cameraControlsEventDistribution);
        this.boundingBox = __classPrivateFieldGet(this, _PerspectiveCamera_tree, "f").root.boundingBox.clone();
        (_a = this._stateEngine.viewportEngines[renderingEngine.id]) === null || _a === void 0 ? void 0 : _a.boundingBoxCreated.then(() => __awaiter(this, void 0, void 0, function* () {
            if (this.position[0] === this.target[0] &&
                this.position[1] === this.target[1] &&
                this.position[2] === this.target[2])
                yield this.zoomTo(undefined, { duration: 0 });
        }));
    }
    calculateZoomTo(zoomTarget, startingPosition = this.position, startingTarget = this.target) {
        let box;
        // Part 1 - calculate the bounding box that we should zoom to
        if (!zoomTarget) {
            // complete scene
            box = this._boundingBox.clone();
        }
        else {
            // specified Box
            box = zoomTarget.clone();
        }
        if (box.isEmpty())
            return { position: startingPosition, target: startingTarget };
        const invalidInput = startingPosition[0] === startingTarget[0] &&
            startingPosition[1] === startingTarget[1] &&
            startingPosition[2] === startingTarget[2];
        const target = gl_matrix_1.vec3.fromValues((box.max[0] + box.min[0]) / 2, (box.max[1] + box.min[1]) / 2, (box.max[2] + box.min[2]) / 2);
        // if the camera position and the target are the same, we set a corner position
        if (invalidInput)
            startingPosition = gl_matrix_1.vec3.fromValues(target[0], target[1] - 7.5, target[2] + 5);
        // extend box by the factor
        const boxDir = gl_matrix_1.vec3.subtract(gl_matrix_1.vec3.create(), box.max, target);
        gl_matrix_1.vec3.multiply(boxDir, boxDir, invalidInput
            ? gl_matrix_1.vec3.fromValues(2, 2, 2)
            : gl_matrix_1.vec3.fromValues(this.zoomExtentsFactor, this.zoomExtentsFactor, this.zoomExtentsFactor));
        box = new viewer_shared_math_1.Box(gl_matrix_1.vec3.subtract(gl_matrix_1.vec3.create(), target, boxDir), gl_matrix_1.vec3.add(gl_matrix_1.vec3.create(), target, boxDir));
        let direction = gl_matrix_1.vec3.create();
        if (invalidInput) {
            direction = gl_matrix_1.vec3.normalize(gl_matrix_1.vec3.create(), gl_matrix_1.vec3.subtract(gl_matrix_1.vec3.create(), target, startingPosition));
        }
        else {
            direction = gl_matrix_1.vec3.normalize(gl_matrix_1.vec3.create(), gl_matrix_1.vec3.subtract(gl_matrix_1.vec3.create(), startingTarget, startingPosition));
        }
        const cross = gl_matrix_1.vec3.normalize(gl_matrix_1.vec3.create(), gl_matrix_1.vec3.cross(gl_matrix_1.vec3.create(), gl_matrix_1.vec3.fromValues(0, 0, 1), direction));
        const up = gl_matrix_1.vec3.normalize(gl_matrix_1.vec3.create(), gl_matrix_1.vec3.cross(gl_matrix_1.vec3.create(), cross, direction));
        let position = gl_matrix_1.vec3.add(gl_matrix_1.vec3.create(), target, gl_matrix_1.vec3.multiply(gl_matrix_1.vec3.create(), direction, gl_matrix_1.vec3.fromValues(-0.00000001, -0.00000001, -0.00000001)));
        const points = [];
        points.push(gl_matrix_1.vec3.fromValues(box.min[0], box.min[1], box.min[2]));
        points.push(gl_matrix_1.vec3.fromValues(box.min[0], box.min[1], box.max[2]));
        points.push(gl_matrix_1.vec3.fromValues(box.min[0], box.max[1], box.min[2]));
        points.push(gl_matrix_1.vec3.fromValues(box.min[0], box.max[1], box.max[2]));
        points.push(gl_matrix_1.vec3.fromValues(box.max[0], box.min[1], box.min[2]));
        points.push(gl_matrix_1.vec3.fromValues(box.max[0], box.min[1], box.max[2]));
        points.push(gl_matrix_1.vec3.fromValues(box.max[0], box.max[1], box.min[2]));
        points.push(gl_matrix_1.vec3.fromValues(box.max[0], box.max[1], box.max[2]));
        const fovDown = gl_matrix_1.vec3.normalize(gl_matrix_1.vec3.create(), gl_matrix_1.vec3.transformQuat(gl_matrix_1.vec3.create(), direction, gl_matrix_1.quat.setAxisAngle(gl_matrix_1.quat.create(), cross, (this.fov / 2) * (Math.PI / 180))));
        const fovUp = gl_matrix_1.vec3.normalize(gl_matrix_1.vec3.create(), gl_matrix_1.vec3.transformQuat(gl_matrix_1.vec3.create(), direction, gl_matrix_1.quat.setAxisAngle(gl_matrix_1.quat.create(), cross, -(this.fov / 2) * (Math.PI / 180))));
        const aspect = invalidInput ? 1.5 : this.aspect || 1.5;
        const hFoV = 2 * Math.atan(Math.tan((this.fov * Math.PI) / 180 / 2) * aspect);
        const fovRight = gl_matrix_1.vec3.normalize(gl_matrix_1.vec3.create(), gl_matrix_1.vec3.transformQuat(gl_matrix_1.vec3.create(), direction, gl_matrix_1.quat.setAxisAngle(gl_matrix_1.quat.create(), up, hFoV / 2)));
        const fovLeft = gl_matrix_1.vec3.normalize(gl_matrix_1.vec3.create(), gl_matrix_1.vec3.transformQuat(gl_matrix_1.vec3.create(), direction, gl_matrix_1.quat.setAxisAngle(gl_matrix_1.quat.create(), up, -hFoV / 2)));
        const planeCross = new viewer_shared_math_1.Plane();
        planeCross.setFromNormalAndCoplanarPoint(gl_matrix_1.vec3.clone(cross), gl_matrix_1.vec3.clone(target));
        const planeUp = new viewer_shared_math_1.Plane();
        planeUp.setFromNormalAndCoplanarPoint(gl_matrix_1.vec3.clone(up), gl_matrix_1.vec3.clone(target));
        let distanceCamera = 0.0;
        for (let i = 0; i < points.length; i++) {
            let projected = planeCross.clampPoint(points[i]);
            let toP = gl_matrix_1.vec3.normalize(gl_matrix_1.vec3.create(), gl_matrix_1.vec3.subtract(gl_matrix_1.vec3.create(), projected, position));
            if (gl_matrix_1.vec3.dot(direction, fovDown) > gl_matrix_1.vec3.dot(direction, toP)) {
                const currentDir = gl_matrix_1.vec3.multiply(gl_matrix_1.vec3.create(), gl_matrix_1.vec3.dot(fovDown, toP) > gl_matrix_1.vec3.dot(fovUp, toP)
                    ? fovDown
                    : fovUp, gl_matrix_1.vec3.fromValues(-1, -1, -1));
                const distance = planeUp.intersect(projected, currentDir);
                if (distance) {
                    const cameraPoint = gl_matrix_1.vec3.add(gl_matrix_1.vec3.create(), gl_matrix_1.vec3.multiply(gl_matrix_1.vec3.create(), currentDir, gl_matrix_1.vec3.fromValues(distance, distance, distance)), projected);
                    distanceCamera = Math.max(distanceCamera, gl_matrix_1.vec3.distance(target, cameraPoint));
                }
            }
            projected = planeUp.clampPoint(points[i]);
            toP = gl_matrix_1.vec3.normalize(gl_matrix_1.vec3.create(), gl_matrix_1.vec3.subtract(gl_matrix_1.vec3.create(), projected, position));
            if (gl_matrix_1.vec3.dot(direction, fovRight) > gl_matrix_1.vec3.dot(direction, toP)) {
                const currentDir = gl_matrix_1.vec3.multiply(gl_matrix_1.vec3.create(), gl_matrix_1.vec3.dot(fovRight, toP) > gl_matrix_1.vec3.dot(fovLeft, toP)
                    ? fovRight
                    : fovLeft, gl_matrix_1.vec3.fromValues(-1, -1, -1));
                const distance = planeCross.intersect(projected, currentDir);
                if (distance) {
                    const cameraPoint = gl_matrix_1.vec3.add(gl_matrix_1.vec3.create(), gl_matrix_1.vec3.multiply(gl_matrix_1.vec3.create(), currentDir, gl_matrix_1.vec3.fromValues(distance, distance, distance)), projected);
                    distanceCamera = Math.max(distanceCamera, gl_matrix_1.vec3.distance(target, cameraPoint));
                }
            }
        }
        position = gl_matrix_1.vec3.add(gl_matrix_1.vec3.create(), target, gl_matrix_1.vec3.multiply(gl_matrix_1.vec3.create(), direction, gl_matrix_1.vec3.fromValues(-distanceCamera, -distanceCamera, -distanceCamera)));
        return {
            position,
            target,
        };
    }
    clone() {
        return new PerspectiveCamera(this.id, this.version, this.aspect);
    }
    project(pos, position = this.position, target = this.target) {
        const m = gl_matrix_1.mat4.targetTo(gl_matrix_1.mat4.create(), position, target, gl_matrix_1.vec3.fromValues(0, 0, 1));
        const aspect = this.aspect || 1.5;
        const p = gl_matrix_1.mat4.perspective(gl_matrix_1.mat4.create(), this.fov / (180 / Math.PI), aspect, this.near, this.far);
        let inverse = gl_matrix_1.mat4.invert(gl_matrix_1.mat4.create(), m);
        if (!inverse)
            inverse = gl_matrix_1.mat4.create();
        gl_matrix_1.vec3.transformMat4(pos, pos, inverse);
        gl_matrix_1.vec3.transformMat4(pos, pos, p);
        return gl_matrix_1.vec2.fromValues(pos[0], pos[1]);
    }
    unproject(pos, position = this.position, target = this.target) {
        const m = gl_matrix_1.mat4.targetTo(gl_matrix_1.mat4.create(), position, target, gl_matrix_1.vec3.fromValues(0, 0, 1));
        const aspect = this.aspect || 1.5;
        const p = gl_matrix_1.mat4.perspective(gl_matrix_1.mat4.create(), this.fov / (180 / Math.PI), aspect, this.near, this.far);
        let inverse = gl_matrix_1.mat4.invert(gl_matrix_1.mat4.create(), p);
        if (!inverse)
            inverse = gl_matrix_1.mat4.create();
        gl_matrix_1.vec3.transformMat4(pos, pos, inverse);
        gl_matrix_1.vec3.transformMat4(pos, pos, m);
        return gl_matrix_1.vec3.clone(pos);
    }
    // #endregion Public Methods (6)
    // #region Protected Methods (1)
    getProjectionMatrix(sphere) {
        if (!this.aspect || sphere.radius === 0)
            return;
        const far = this.fov < 10
            ? this.fov * 100.0 * 100 * sphere.radius
            : 100 * sphere.radius;
        const near = this.fov < 10
            ? this.fov * 100.0 * 0.01 * sphere.radius
            : 0.01 * sphere.radius;
        return gl_matrix_1.mat4.perspective(gl_matrix_1.mat4.create(), this.fov / (180 / Math.PI), this.aspect, near, far);
    }
}
exports.PerspectiveCamera = PerspectiveCamera;
_PerspectiveCamera_converter = new WeakMap(), _PerspectiveCamera_tree = new WeakMap(), _PerspectiveCamera_aspect = new WeakMap(), _PerspectiveCamera_domEventEngine = new WeakMap(), _PerspectiveCamera_fov = new WeakMap();
//# sourceMappingURL=PerspectiveCamera.js.map